// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"Message_messageBox__2-pPQ"};